module.exports = __webpack_public_path__ + "static/media/foto2.5011fe64.jpg";